import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent } from '@app/core/loading/component/loading.component';

@Component({
  selector: 'ess-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, LoadingComponent],
})
export class AppComponent {}
